module.exports = __webpack_public_path__ + "img/chickenburger2.ef0111cf.jpg";